// extracted by mini-css-extract-plugin
export default {"labelWrapper":"RadioButton_labelWrapper__VAZkq"};